import http from '../../../http'

const state = {
    sendList: [],
    page: {
        current: 1,
        pageSize: 15,
        pageSizes: [15,30,50,100],
        total: 0
    },

};

const mutations = {
    SET_SEND_LIST: (state, payload)=> {
        state.sendList = payload;
    },
    SET_PAGE_CURRENT(state, current) {
        state.page.current = current;
    },
    SET_PAGE_SIZE(state, pageSize) {
        state.page.pageSize = pageSize;
    },
    SET_PAGE_TOTAL(state, total) {
        state.page.total = total;
    }

};

const actions = {

    doSave: ({commit}, params) =>{
        return new Promise((resolve =>{
            http.post('/supplier-resource/orderTimes/doSave', params).then((res)=>{
                resolve(res.data);
            })
        }));
    },

    listPage({commit}, params) {
        return new Promise((resolve) => {
            http.post('/supplier-resource/orderTimes/listPage', params).then((res) => {
                resolve(res.data);
            });
        });
    },
    exportExcel({commit, state}, payload) {
        let params = payload;
        http.download('/supplier-resource/orderTimes/exportExcel', 'get', params);
    },
    send({commit}, params) {
        return new Promise((resolve) => {
            http.post('/supplier-resource/sap/pushArriveTime', params).then((res) => {
                resolve(res.data);
            });
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
